import { CommaArrayParam } from 'helpers/CommaArrayParam';
import { useQueryParam, withDefault } from 'use-query-params';

const PcModelDelayMessage = ({ option, closeModal }) => {
  const [, setCurrentStep] = useQueryParam('step');
  const [completed, setCompleted] = useQueryParam(
    'completed',
    withDefault(CommaArrayParam, []),
  );
  const handleClick = () => {
    setCurrentStep(option.group_step_new);
    setCompleted(completed.filter((item) => item !== option.group_type));
    setTimeout(() => {
      document
        .getElementById(`group-type-${option.group_type}`)
        .scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
    }, 500);
    if (closeModal) {
      closeModal();
    }
  };
  return (
    <>
      <div className="delay-message">
        Your&nbsp;
        <button className="component-type" onClick={handleClick} type="button">
          {option.group_title}
        </button>
        &nbsp;{option.title}&nbsp;is low in stock and will take longer to source
      </div>
      <style jsx>
        {`
          .delay-message {
            font-size: 16px;
            line-height: 24px;
            color: #e4e4e4;
          }
          .component-type {
            color: #0091ff;
            width: auto;
            min-width: unset;
            display: inline;
            background: transparent;
            padding: 0;
            margin: 0;
            border: 0;
            font-size: 16px;
          }
          .component-type:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </>
  );
};

export default PcModelDelayMessage;
